import {Currency} from "../generated/graphql";

export type CurrencyShort = "EUR" | "CHF" | "USD" | "GBP";

// Der Server liefert die Enum-Schlüssel ("Chf"), die DB speichert die ISO-Codes ("CHF").
// Beide Schreibweisen landen hier, deshalb kennt die Tabelle beide.
const CURRENCY_CODES: {[key: string]: CurrencyShort} = {
    Eur: "EUR",
    EUR: "EUR",
    Chf: "CHF",
    CHF: "CHF",
    Usd: "USD",
    USD: "USD",
    Gbp: "GBP",
    GBP: "GBP",
};

// Währung des Mandanten, gesetzt von CurrencyBootstrap beim App-Start.
// Ohne diesen Default formatierte JEDE Aufrufstelle ohne explizites currency-Argument
// in Euro — Schweizer Mandanten sahen "7,00 €" statt "CHF 7.00".
let defaultCurrencyCode: CurrencyShort = "EUR";

const toCurrencyCode = (currency?: Currency | CurrencyShort | null): CurrencyShort =>
    (currency && CURRENCY_CODES[currency]) || defaultCurrencyCode;

/**
 * Setzt die Mandanten-Währung für alle Aufrufe ohne explizites currency-Argument.
 * Ohne Argument fällt der Default auf Euro zurück — so setzen Tests ihn zurück.
 */
export const setDefaultCurrency = (currency?: Currency | CurrencyShort | null): void => {
    defaultCurrencyCode = (currency && CURRENCY_CODES[currency]) || "EUR";
};

export const renderAmount = ({amount, short, currency, localeOverwrite}: {amount: number; short?: boolean; currency?: Currency | CurrencyShort; localeOverwrite?: string}): string => {
    const currencyCode = toCurrencyCode(currency);

    // Fallback für Server/Test-Umgebungen ohne navigator
    const browserLocale = typeof navigator !== "undefined" ? navigator.language : "de-DE";
    // Schweizer Franken brauchen die Schweizer Konvention (CHF 1'234.50) — die deutsche
    // Locale würde "1.234,50 CHF" liefern, also Punkt als Tausender- und Komma als
    // Dezimaltrennzeichen. Genau umgekehrt zur Schweizer Schreibweise.
    const locales = localeOverwrite ?? (currencyCode === "CHF" ? "de-CH" : browserLocale);

    const digits = short ? (amount % 1 === 0 ? 0 : 2) : 2;
    const formatter = new Intl.NumberFormat(locales, {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: digits,
    });

    return formatter.format(amount);
};
